export const SETTINGS_SECTION_KEYS = [
  'userdata',
  'notifications',
  'security',
  'general',
  'profile',
  'legal',
] as const;

export type SettingsSectionKey = typeof SETTINGS_SECTION_KEYS[number];

export type SettingsSectionOpenState = Record<SettingsSectionKey, boolean>;

export const DEFAULT_SETTINGS_SECTION: SettingsSectionKey = 'notifications';

export const getAvailableSettingsSectionKeys = (isFreelancer:boolean): SettingsSectionKey[] => (
  SETTINGS_SECTION_KEYS.filter((key) => isFreelancer || key !== 'profile')
);

export const resolveSettingsSection = (
  section:string | undefined,
  isFreelancer:boolean
): SettingsSectionKey | null => {
  if (!section) return null;
  const availableSections = getAvailableSettingsSectionKeys(isFreelancer);
  return availableSections.includes(section as SettingsSectionKey)
    ? section as SettingsSectionKey
    : null;
};

export const createSettingsSectionOpenState = (
  activeSection:SettingsSectionKey | null,
  isFreelancer:boolean
): SettingsSectionOpenState => {
  const fallbackSection = activeSection ?? DEFAULT_SETTINGS_SECTION;
  const availableSections = getAvailableSettingsSectionKeys(isFreelancer);

  return SETTINGS_SECTION_KEYS.reduce((result, sectionKey) => ({
    ...result,
    [sectionKey]: availableSections.includes(sectionKey) && sectionKey === fallbackSection
  }), {} as SettingsSectionOpenState);
};
